import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useAppSelector } from '../../../../app/store';

interface CodingReviewStampProps {
  caseData?: any;
}

const CodingReviewStamp: React.FC<CodingReviewStampProps> = ({ caseData }) => {
  const { currentCase } = useAppSelector(state => state.caseManage);

  const status = currentCase?.codingReviewStatus || caseData?.codingReviewStatus;
  const reviewBy = currentCase?.codingReviewBy || caseData?.codingReviewBy;
  const reviewDate = currentCase?.codingReviewDate || caseData?.codingReviewDate;

  if (!status) {
    return null;
  }

  return (
    <Stack alignItems="flex-end" spacing={0.5}>
      {/* Approval/Denied/Pending Stamp */}
      {status === 'Approved' && (
        <Box sx={{
          transform: 'rotate(-15deg)',
          border: '3px solid #22c55e',
          borderRadius: '8px',
          padding: '8px 16px',
          backgroundColor: 'rgba(34, 197, 94, 0.1)',
          fontWeight: 'bold',
          fontSize: '1.1rem',
          color: '#22c55e',
          letterSpacing: '2px'
        }}>
          APPROVED
        </Box>
      )}
      
      {status === 'Denied' && (
        <Box sx={{
          transform: 'rotate(-15deg)',
          border: '3px solid #ef4444',
          borderRadius: '8px',
          padding: '8px 16px',
          backgroundColor: 'rgba(239, 68, 68, 0.1)',
          fontWeight: 'bold',
          fontSize: '1.1rem',
          color: '#ef4444',
          letterSpacing: '2px'
        }}>
          DENIED
        </Box>
      )}

      {status === 'Pending' && (
        <Box sx={{
          transform: 'rotate(-15deg)',
          border: '3px solid #f59e0b',
          borderRadius: '8px',
          padding: '8px 16px',
          backgroundColor: 'rgba(245, 158, 11, 0.1)',
          fontWeight: 'bold',
          fontSize: '1.1rem',
          color: '#f59e0b',
          letterSpacing: '2px'
        }}>
          PENDING
        </Box>
      )}
      
      {/* User and Date - vertically stacked, right-aligned */}
      {reviewBy && (
        <Typography variant="body2" sx={{ textAlign: 'right', mt: 1 }}>
          {reviewBy}
        </Typography>
      )}
      {reviewDate && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'right' }}>
          {new Date(reviewDate).toLocaleDateString()}
        </Typography>
      )}
    </Stack>
  );
};

export default CodingReviewStamp;
